<template>
  <div class="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
    <!-- En-tête avec Logo -->
    <div class="text-center mb-8 border-b pb-4">
      <div class="flex justify-center mb-4">
        <img 
          src="images/logo.png" 
          alt="Profert" 
          class="h-20 w-auto object-contain"
          @error="handleImageError"
        >
      </div>
      <h2 class="text-xl font-semibold text-blue-900 mt-2">FORMULAIRE DE RÉCLAMATION CLIENT</h2>
      <p class="w-3/5 mx-auto text-center text-sm text-gray-600 mt-2">
        Il est recommandé de compléter les champs de ce formulaire, cela pourrait rendre le traitement de votre réclamation facile, rapide et efficace.
      </p>
    </div>

    <form @submit.prevent="submitForm" class="space-y-6">
      <!-- Section INFORMATIONS CLIENT -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">INFORMATIONS CLIENT</h3>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Nom et prénom (ligne 1) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Nom et prénom <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              v-model="form.nom_prenom"
              required
              placeholder="Entrez votre nom complet"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

          <!-- Email (ligne 1) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Email
            </label>
            <input
              type="email"
              v-model="form.email"
              placeholder="votre@email.com"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

          <!-- Statut (ligne 2) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Statut <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.statut"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Choisissez un statut</option>
              <option value="agriculteur">Agriculteur</option>
              <option value="grainetier">Grainetier</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <!-- Wilaya (ligne 2) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Wilaya <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.wilaya"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Choisissez votre wilaya</option>
              <option value="Adrar">01 - Adrar</option>
              <option value="Chlef">02 - Chlef</option>
              <option value="Laghouat">03 - Laghouat</option>
              <option value="Oum El Bouaghi">04 - Oum El Bouaghi</option>
              <option value="Batna">05 - Batna</option>
              <option value="Béjaïa">06 - Béjaïa</option>
              <option value="Biskra">07 - Biskra</option>
              <option value="Béchar">08 - Béchar</option>
              <option value="Blida">09 - Blida</option>
              <option value="Bouira">10 - Bouira</option>
              <option value="Tamanrasset">11 - Tamanrasset</option>
              <option value="Tébessa">12 - Tébessa</option>
              <option value="Tlemcen">13 - Tlemcen</option>
              <option value="Tiaret">14 - Tiaret</option>
              <option value="Tizi Ouzou">15 - Tizi Ouzou</option>
              <option value="Alger">16 - Alger</option>
              <option value="Djelfa">17 - Djelfa</option>
              <option value="Jijel">18 - Jijel</option>
              <option value="Sétif">19 - Sétif</option>
              <option value="Saïda">20 - Saïda</option>
              <option value="Skikda">21 - Skikda</option>
              <option value="Sidi Bel Abbès">22 - Sidi Bel Abbès</option>
              <option value="Annaba">23 - Annaba</option>
              <option value="Guelma">24 - Guelma</option>
              <option value="Constantine">25 - Constantine</option>
              <option value="Médéa">26 - Médéa</option>
              <option value="Mostaganem">27 - Mostaganem</option>
              <option value="M'Sila">28 - M'Sila</option>
              <option value="Mascara">29 - Mascara</option>
              <option value="Ouargla">30 - Ouargla</option>
              <option value="Oran">31 - Oran</option>
              <option value="El Bayadh">32 - El Bayadh</option>
              <option value="Illizi">33 - Illizi</option>
              <option value="Bordj Bou Arréridj">34 - Bordj Bou Arréridj</option>
              <option value="Boumerdès">35 - Boumerdès</option>
              <option value="El Tarf">36 - El Tarf</option>
              <option value="Tindouf">37 - Tindouf</option>
              <option value="Tissemsilt">38 - Tissemsilt</option>
              <option value="El Oued">39 - El Oued</option>
              <option value="Khenchela">40 - Khenchela</option>
              <option value="Souk Ahras">41 - Souk Ahras</option>
              <option value="Tipaza">42 - Tipaza</option>
              <option value="Mila">43 - Mila</option>
              <option value="Aïn Defla">44 - Aïn Defla</option>
              <option value="Naâma">45 - Naâma</option>
              <option value="Aïn Témouchent">46 - Aïn Témouchent</option>
              <option value="Ghardaïa">47 - Ghardaïa</option>
              <option value="Relizane">48 - Relizane</option>
              <option value="El M'Ghair">49 - El M'Ghair</option>
              <option value="El Menia">50 - El Menia</option>
              <option value="Ouled Djellal">51 - Ouled Djellal</option>
              <option value="Bordj Badji Mokhtar">52 - Bordj Badji Mokhtar</option>
              <option value="Béni Abbès">53 - Béni Abbès</option>
              <option value="Timimoun">54 - Timimoun</option>
              <option value="Touggourt">55 - Touggourt</option>
              <option value="Djanet">56 - Djanet</option>
              <option value="In Salah">57 - In Salah</option>
              <option value="In Guezzam">58 - In Guezzam</option>
            </select>
          </div>

          <!-- Téléphone (ligne 3) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Téléphone <span class="text-red-500">*</span>
            </label>
            <div class="flex">
              <div class="relative">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <span class="text-gray-500">+213</span>
                </div>
                <input
                  type="tel"
                  v-model="form.telephone"
                  @input="formatPhoneNumber"
                  required
                  maxlength="9"
                  placeholder="551234567"
                  class="w-full pl-16 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
              </div>
            </div>
            <p class="text-xs text-gray-500 mt-1" v-if="form.telephone">
              {{ 9 - form.telephone.replace(/\D/g, '').length }} chiffres restants
            </p>
          </div>

          <!-- Code client (ligne 3) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Code client
            </label>
            <input
              type="text"
              v-model="form.codeclient"
              placeholder="Code client"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

          <!-- Canal d'achat (ligne complète) -->
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Canal d'achat <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.canal_achat"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Choisissez le canal d'achat</option>
              <option value="profert">Profert</option>
              <option value="grainetier">Grainetier</option>
              <option value="ccls">CCLS</option>
            </select>
          </div>

          <!-- Représentant Profert (ligne complète) -->
          <div class="md:col-span-2">
            <div class="mb-4">
              <label class="flex items-center space-x-2">
                <input
                  type="checkbox"
                  v-model="form.has_representant"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                >
                <span class="text-sm font-medium text-gray-700">Avez-vous un représentant Profert ?</span>
              </label>
            </div>
            
            <div v-if="form.has_representant">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Représentant Profert
              </label>
              <input
                type="text"
                v-model="form.representant_profert"
                placeholder="Nom du représentant Profert"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Section PRODUIT -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">INFORMATIONS PRODUIT</h3>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Gamme de produit (ligne 1) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Gamme de produit <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.gamme_produit"
              @change="onGammeChange"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              :disabled="loadingGammes"
            >
              <option value="">Choisissez une gamme</option>
              <option 
                v-for="gamme in gammes" 
                :key="gamme.id" 
                :value="gamme.id"
              >
                {{ gamme.name }}
              </option>
            </select>
            <div v-if="loadingGammes" class="text-sm text-gray-500 mt-1">
              Chargement des gammes...
            </div>
          </div>

          <!-- Produit avec recherche intégrée (version simplifiée) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Produit <span class="text-red-500">*</span>
            </label>
            
            <div class="relative">
              <!-- Input de recherche avec dropdown intégré -->
              <div class="relative">
                <input 
                  type="text" 
                  v-model="produitSearch"
                  @focus="onProduitInputFocus"
                  @blur="onProduitInputBlur"
                  @input="filterProduits"
                  @keydown.down="navigateDropdown('down')"
                  @keydown.up="navigateDropdown('up')"
                  @keydown.enter="selectHighlightedProduit"
                  :placeholder="form.gamme_produit ? 'Recherchez ou sélectionnez un produit...' : 'Sélectionnez d\'abord une gamme'"
                  :class="[
                    'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2',
                    !form.gamme_produit || loadingProduits ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' : 
                    showProduitDropdown && filteredProduits.length > 0 ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-300 focus:ring-blue-500'
                  ]"
                  :disabled="!form.gamme_produit || loadingProduits"
                  ref="produitInput"
                >

                <!-- Icône de recherche -->
                <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <i v-if="loadingProduits" class="fas fa-spinner fa-spin text-gray-400"></i>
                  <i v-else-if="!loadingProduits && form.gamme_produit" class="fas fa-search text-gray-400"></i>
                </div>

                <!-- Dropdown des résultats -->
                <div 
                  v-if="showProduitDropdown && filteredProduits.length > 0" 
                  class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto"
                  ref="dropdown"
                >
                  <div 
                    v-for="(produit, index) in filteredProduits" 
                    :key="produit.id"
                    @mousedown="selectProduit(produit)"
                    :class="[
                      'px-3 py-2 cursor-pointer transition-colors',
                      index === highlightedIndex ? 'bg-blue-100 text-blue-700' : 'hover:bg-blue-50',
                      form.produit_id == produit.id ? 'bg-blue-50 text-blue-700 font-medium' : ''
                    ]"
                  >
                    {{ produit.name }}
                  </div>
                </div>
              </div>

              <!-- Champ caché pour stocker l'ID du produit -->
              <input type="hidden" v-model="form.produit_id" required>

              <!-- Message de chargement -->
              <div v-if="loadingProduits" class="text-sm text-gray-500 mt-1">
                Chargement des produits...
              </div>

              <!-- Message si aucun résultat -->
              <div 
                v-if="produitSearch && filteredProduits.length === 0 && !loadingProduits && form.gamme_produit" 
                class="text-sm text-gray-500 mt-1"
              >
                Aucun produit trouvé pour "{{ produitSearch }}"
              </div>

              <!-- Message si pas de gamme sélectionnée -->
              <div 
                v-if="!form.gamme_produit" 
                class="text-sm text-yellow-600 mt-1"
              >
                Veuillez d'abord sélectionner une gamme
              </div>
            </div>
          </div>

          <!-- Motif de la réclamation (ligne 2) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Motif de la réclamation <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.motif"
              required
              @change="onMotifChange"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              :disabled="loadingMotifs"
            >
              <option value="">Choisissez un motif</option>
              <option 
                v-for="motif in motifs" 
                :key="motif.id" 
                :value="motif.id"
              >
                {{ motif.name }}
              </option>
            </select>
            <div v-if="loadingMotifs" class="text-sm text-gray-500 mt-1">
              Chargement des motifs...
            </div>
          </div>

          <!-- Numéro de lot (ligne 2) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              N° Lot <span v-if="isNumeroLotRequired" class="text-red-500">*</span>
            </label>
            <input
              type="text"
              v-model="form.numero_lot"
              :required="isNumeroLotRequired"
              placeholder="Numéro du lot"
              :class="[
                'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2',
                isNumeroLotRequired && !form.numero_lot ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
              ]"
            >
            <p v-if="isNumeroLotRequired && !form.numero_lot" class="text-sm text-red-600 mt-1">
              <i class="fas fa-exclamation-circle mr-1"></i>
              Ce champ est obligatoire pour ce motif
            </p>
          </div>

          <!-- Date de livraison (ligne 3) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Date de livraison <span class="text-red-500">*</span>
            </label>
            <input
              type="date"
              v-model="form.date_livraison"
              @change="validateDateLivraison"
              :max="maxDate"
              :class="[
                'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2',
                dateError ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
              ]"
              required
            >
            <!-- Message d'erreur -->
            <p v-if="dateError" class="text-sm text-red-600 mt-1">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ dateError }}
            </p>
            <!-- Astuce pour l'utilisateur -->
            <p v-else class="text-xs text-gray-500 mt-1">
              La date ne peut pas être postérieure à aujourd'hui
            </p>
          </div>

          <!-- Quantité non conforme (ligne 3) -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Quantité non conforme
            </label>
            <input
              type="text"
              v-model="form.quantite_non_conforme"
              placeholder="Ex: 10 kg, 5 sacs, etc."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>
        </div>

        <!-- Upload de fichiers (section séparée) -->
        <div v-if="form.motif" class="mt-6 pt-6 border-t">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Fichiers joints (Images, PDF, Word)
          </label>
          
          <!-- Zone de drag & drop -->
          <div
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
            :class="[
              'border-2 border-dashed rounded-lg p-6 text-center transition-colors',
              isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'
            ]"
          >
            <i class="fas fa-cloud-upload-alt text-4xl text-gray-400 mb-3"></i>
            <p class="text-sm text-gray-600 mb-2">
              Glissez et déposez vos fichiers ici, ou
            </p>
            <label class="cursor-pointer">
              <span class="text-blue-600 hover:text-blue-700 font-medium">parcourir les fichiers</span>
              <input
                type="file"
                @change="handleFileSelect"
                multiple
                accept="image/*,.pdf,.doc,.docx"
                class="hidden"
              >
            </label>
            <p class="text-xs text-gray-500 mt-2">
              Formats acceptés: Images (JPG, PNG), PDF, Word (DOC, DOCX)
            </p>
          </div>

          <!-- Liste des fichiers sélectionnés -->
          <div v-if="selectedFiles.length > 0" class="mt-4 space-y-2">
            <div
              v-for="(file, index) in selectedFiles"
              :key="index"
              class="flex items-center justify-between p-3 bg-gray-50 rounded-md border border-gray-200"
            >
              <div class="flex items-center space-x-3">
                <i :class="getFileIcon(file.type)" class="text-gray-500"></i>
                <div>
                  <p class="text-sm font-medium text-gray-700">{{ file.name }}</p>
                  <p class="text-xs text-gray-500">{{ formatFileSize(file.size) }}</p>
                </div>
              </div>
              <button
                type="button"
                @click="removeFile(index)"
                class="text-red-500 hover:text-red-700"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section DESCRIPTION -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">DESCRIPTION</h3>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Description détaillée de la réclamation
          </label>
          <textarea
            v-model="form.description"
            rows="6"
            placeholder="Décrivez en détail le problème rencontré..."
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-vertical"
          ></textarea>
        </div>
      </div>

      <!-- Section CAPTCHA et Boutons -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <div class="flex flex-wrap items-center justify-between gap-4">
          <!-- Code CAPTCHA affiché -->
          <div class="flex items-center gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
            <div class="bg-gray-100 px-3 py-2 rounded-md border-2 border-dashed border-blue-300">
              <span class="text-lg font-mono font-bold text-blue-600 tracking-wider select-none">
                {{ captcha.num1 }} + {{ captcha.num2 }} = ?
              </span>
            </div>

            <!-- Input pour la réponse -->
            <div class="flex flex-col items-center">
              <input
                type="number"
                v-model="captcha.userInput"
                @input="validateCaptcha"
                class="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-center font-mono"
                placeholder="Résultat"
                min="0"
                max="20"
              >
              <button
                type="button"
                @click="generateCaptcha"
                class="text-blue-600 hover:text-blue-700 text-xs mt-1 flex items-center justify-center"
              >
                <i class="fas fa-redo mr-1"></i>
                Nouveau calcul
              </button>
            </div>

            <!-- Indicateur de validation -->
            <div class="ml-4">
              <div v-if="captcha.isValid" class="text-green-600 text-sm flex items-center">
                <i class="fas fa-check-circle mr-1"></i>
                Bonne réponse !
              </div>
              <div v-else-if="captcha.userInput" class="text-red-600 text-sm flex items-center">
                <i class="fas fa-times-circle mr-1"></i>
                Réponse incorrecte
              </div>
            </div>
          </div>

          <!-- Boutons d'action -->
          <div class="flex items-center gap-3">
            <button
              type="button"
              @click="resetForm"
              class="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition flex items-center justify-center"
            >
              <i class="fas fa-redo mr-2"></i>
              Réinitialiser
            </button>
            <button
              type="submit"
              :disabled="isSubmitting || !captcha.isValid"
              class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center"
            >
              <i class="fas fa-paper-plane mr-2"></i>
              {{ isSubmitting ? 'Envoi...' : 'Soumettre' }}
            </button>
          </div>
        </div>

        <p class="text-xs text-gray-500 text-center mt-2">
          Cette vérification protège contre les soumissions automatisées.
        </p>
      </div>
    </form>

    <!-- Modal de confirmation -->
    <div v-if="showSuccess" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg max-w-md mx-4 shadow-2xl">
        <div class="text-center">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i class="fas fa-check text-green-600 text-2xl"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-800 mb-2">Réclamation envoyée !</h3>
          <p class="text-gray-600 mb-4">Votre réclamation a été soumise avec succès. Nous la traiterons dans les plus brefs délais.</p>
          <button
            @click="closeSuccessModal"
            class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReclamationForm',
  data() {
    return {
      form: {
        nom_prenom: '',
        email: '',
        statut: '',
        wilaya: '',
        telephone: '',
        codeclient: '',
        canal_achat: '',
        has_representant: false,
        representant_profert: '',
        gamme_produit: '',
        produit_id: '',
        numero_lot: '',
        date_livraison: '',
        quantite_non_conforme: '',
        motif: '',
        description: ''
      },
      gammes: [],
      produits: [],
      motifs: [],
      selectedFiles: [],
      isDragging: false,
      showSuccess: false,
      isSubmitting: false,
      loadingGammes: false,
      loadingProduits: false,
      loadingMotifs: false,
      captcha: {
        num1: 0,
        num2: 0,
        result: 0,
        userInput: '',
        isValid: false
      },
      produitSearch: '',
      allProduits: [],
      filteredProduits: [],
      showProduitDropdown: false,
      highlightedIndex: -1,
      dateError: '',
      maxDate: '',
      qualityMotifIds: []
    }
  },
  
  computed: {
    isNumeroLotRequired() {
      if (!this.form.motif) return false;
      
      const selectedMotif = this.motifs.find(m => m.id == this.form.motif);
      if (!selectedMotif) return false;
      
      const motifName = selectedMotif.name.toLowerCase();
      return motifName.includes('qualité') || motifName.includes('qualite');
    }
  },
  
  watch: {
    'form.produit_id'(newVal) {
      if (newVal && this.allProduits.length > 0) {
        const produit = this.allProduits.find(p => p.id == newVal);
        if (produit) {
          this.produitSearch = produit.name;
        }
      } else if (!newVal) {
        this.produitSearch = '';
      }
    },
    'form.motif'(newVal) {
      if (newVal && !this.isNumeroLotRequired) {
        // Ne pas réinitialiser, juste s'assurer que la validation est correcte
      }
    }
  },
  
  async mounted() {
    // Charger les gammes et motifs au montage du composant
    await this.fetchGammes();
    await this.fetchMotifs();
    
    // Générer le premier CAPTCHA
    this.generateCaptcha();

    // Définir la date maximum (aujourd'hui)
    this.setMaxDate();
  },
  
  methods: {
    generateCaptcha() {
      this.captcha.num1 = Math.floor(Math.random() * 10) + 1;
      this.captcha.num2 = Math.floor(Math.random() * 10) + 1;
      this.captcha.result = this.captcha.num1 + this.captcha.num2;
      this.captcha.userInput = '';
      this.captcha.isValid = false;
    },
    
    validateCaptcha() {
      if (!this.captcha.userInput) {
        this.captcha.isValid = false;
        return;
      }
      
      const userAnswer = parseInt(this.captcha.userInput);
      this.captcha.isValid = userAnswer === this.captcha.result;
    },

    async fetchGammes() {
      this.loadingGammes = true;
      try {
        const response = await fetch('/api/gammes', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.gammes = data.data || [];
        } else {
          console.error('Erreur lors du chargement des gammes');
          this.gammes = [];
        }
      } catch (error) {
        console.error('Erreur:', error);
        this.gammes = [];
      } finally {
        this.loadingGammes = false;
      }
    },

    async fetchProduits(gammeId) {
      if (!gammeId) {
        this.allProduits = [];
        this.filteredProduits = [];
        this.produitSearch = '';
        this.form.produit_id = '';
        return;
      }

      this.loadingProduits = true;
      try {
        const response = await fetch(`/api/gammes/${gammeId}/produits`, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.allProduits = data.data || [];
          this.filteredProduits = [...this.allProduits];
          this.produitSearch = '';
          
          // Pour compatibilité
          this.produits = data.data || [];
        } else {
          console.error('Erreur lors du chargement des produits');
          this.allProduits = [];
          this.filteredProduits = [];
          this.produits = [];
        }
      } catch (error) {
        console.error('Erreur:', error);
        this.allProduits = [];
        this.filteredProduits = [];
        this.produits = [];
      } finally {
        this.loadingProduits = false;
      }
    },

    async fetchMotifs() {
      this.loadingMotifs = true;
      try {
        const response = await fetch('/api/motifs', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.motifs = data.data || [];
          
          // Identifier les motifs qualité
          this.qualityMotifIds = this.motifs
            .filter(motif => 
              motif.name.toLowerCase().includes('qualité') || 
              motif.name.toLowerCase().includes('qualite')
            )
            .map(motif => motif.id);
        } else {
          console.error('Erreur lors du chargement des motifs');
          this.motifs = [];
          this.qualityMotifIds = [];
        }
      } catch (error) {
        console.error('Erreur:', error);
        this.motifs = [];
        this.qualityMotifIds = [];
      } finally {
        this.loadingMotifs = false;
      }
    },

    selectProduit(produit) {
      this.form.produit_id = produit.id;
      this.produitSearch = produit.name;
      this.showProduitDropdown = false;
    },

    clearProduitSelection() {
      this.form.produit_id = '';
      this.produitSearch = '';
      this.showProduitDropdown = true;
      this.$nextTick(() => {
        const input = this.$el.querySelector('input[type="text"][v-model="produitSearch"]');
        if (input) input.focus();
      });
    },

    onProduitInputBlur() {
      setTimeout(() => {
        this.showProduitDropdown = false;
      }, 200);
    },

    filterProduits() {
      if (!this.form.gamme_produit) {
        this.filteredProduits = [];
        return;
      }

      const searchTerm = this.produitSearch.toLowerCase().trim();
      
      if (!searchTerm) {
        this.filteredProduits = [...this.allProduits];
      } else {
        this.filteredProduits = this.allProduits.filter(produit =>
          produit.name.toLowerCase().includes(searchTerm)
        );
      }
      
      this.showProduitDropdown = true;
    },

    onGammeChange() {
      this.form.produit_id = '';
      this.produitSearch = '';
      this.showProduitDropdown = false;
      
      if (this.form.gamme_produit) {
        this.fetchProduits(this.form.gamme_produit);
      } else {
        this.allProduits = [];
        this.filteredProduits = [];
      }
    },

    onMotifChange() {
      if (!this.form.motif) {
        this.selectedFiles = [];
      }
    },

    handleImageError(event) {
      event.target.style.display = 'none';
      const title = document.createElement('h1');
      title.className = 'text-2xl font-bold text-gray-800';
      title.textContent = 'Profert';
      event.target.parentElement.appendChild(title);
    },

    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },

    handleDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },

    addFiles(files) {
      const validFiles = files.filter(file => {
        const validTypes = [
          'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];
        return validTypes.includes(file.type) && file.size <= 10 * 1024 * 1024;
      });

      this.selectedFiles = [...this.selectedFiles, ...validFiles];
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    getFileIcon(fileType) {
      if (fileType.startsWith('image/')) return 'fas fa-file-image text-blue-500';
      if (fileType === 'application/pdf') return 'fas fa-file-pdf text-red-500';
      if (fileType.includes('word')) return 'fas fa-file-word text-blue-600';
      return 'fas fa-file text-gray-500';
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    async submitForm() {
      if (!this.captcha.isValid) {
        alert('Veuillez résoudre correctement le calcul de vérification');
        this.generateCaptcha();
        return;
      }
      
      // Valider la date de livraison
      if (this.form.date_livraison && !this.validateDateLivraison()) {
        alert('La date de livraison ne peut pas être postérieure à aujourd\'hui');
        return;
      }
      
      // Valider le numéro de lot pour les motifs qualité
      if (this.isNumeroLotRequired && !this.form.numero_lot) {
        alert('Le numéro de lot est obligatoire pour ce motif de réclamation');
        return;
      }

      if (!this.validateForm()) {
        this.generateCaptcha();
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        
        const selectedGamme = this.gammes.find(g => g.id == this.form.gamme_produit);
        const selectedMotif = this.motifs.find(m => m.id == this.form.motif);
        const selectedProduit = this.allProduits.find(p => p.id == this.form.produit_id);
        
        // Ajouter les données du formulaire
        formData.append('nom_prenom', this.form.nom_prenom);
        formData.append('email', this.form.email);
        formData.append('statut', this.form.statut);
        formData.append('wilaya', this.form.wilaya);
        formData.append('telephone', '+213' + this.form.telephone);
        formData.append('codeclient', this.form.codeclient);
        formData.append('canal_achat', this.form.canal_achat);
        formData.append('has_representant', this.form.has_representant ? '1' : '0');
        formData.append('representant_profert', this.form.representant_profert);

        // Envoyer les noms pour la recherche
        formData.append('gamme_produit', selectedGamme ? selectedGamme.name : '');
        formData.append('motif', selectedMotif ? selectedMotif.name : '');
        formData.append('produit_name', selectedProduit ? selectedProduit.name : '');
        
        formData.append('numero_lot', this.form.numero_lot);
        formData.append('produit_id', this.form.produit_id);
        formData.append('date_livraison', this.form.date_livraison);
        formData.append('quantite_non_conforme', this.form.quantite_non_conforme);
        formData.append('description', this.form.description);

        // Ajouter les données CAPTCHA
        formData.append('captcha_result', this.captcha.result);
        formData.append('captcha_user_input', this.captcha.userInput);

        // Ajouter les fichiers
        this.selectedFiles.forEach((file, index) => {
          formData.append(`fichiers[${index}]`, file);
        });

        const response = await fetch('/reclamation', {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': this.getCsrfToken(),
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const result = await response.json();

        if (response.ok && result.success) {
          this.showSuccess = true;
          this.generateCaptcha();
        } else {
          throw new Error(result.message || 'Erreur lors de la soumission');
        }
        
      } catch (error) {
        console.error('Erreur lors de la soumission:', error);
        alert('Une erreur est survenue lors de la soumission: ' + error.message);
        this.generateCaptcha();
      } finally {
        this.isSubmitting = false;
      }
    },

    getCsrfToken() {
      const metaTag = document.querySelector('meta[name="csrf-token"]');
      if (metaTag) {
        return metaTag.getAttribute('content');
      }

      if (window.Laravel && window.Laravel.csrfToken) {
        return window.Laravel.csrfToken;
      }

      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (cookieValue) {
        return decodeURIComponent(cookieValue);
      }

      console.warn('CSRF token non trouvé');
      return '';
    },

    validateForm() {
      const requiredFields = {
        'nom_prenom': 'Nom et prénom',
        'statut': 'Statut',
        'wilaya': 'Wilaya',
        'telephone': 'Téléphone',
        'canal_achat': 'Canal d\'achat',
        'gamme_produit': 'Gamme de produit',
        'produit_id': 'Produit',
        'motif': 'Motif de la réclamation',
        'date_livraison': 'Date de livraison'
      };

      for (const [field, label] of Object.entries(requiredFields)) {
        if (!this.form[field]) {
          alert(`Le champ "${label}" est obligatoire`);
          return false;
        }
      }

      // Validation du numéro de lot pour les motifs qualité
      if (this.isNumeroLotRequired && !this.form.numero_lot) {
        alert('Le numéro de lot est obligatoire pour ce motif de réclamation');
        return false;
      }

      // Validation de la date de livraison
      if (this.form.date_livraison && !this.validateDateLivraison()) {
        alert('Veuillez corriger la date de livraison');
        return false;
      }

      // Validation email si renseigné
      if (this.form.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.email)) {
          alert('Veuillez entrer une adresse email valide');
          return false;
        }
      }

      // Validation téléphone (9 chiffres)
      const phoneDigits = this.form.telephone.replace(/\D/g, '');
      if (phoneDigits.length !== 9) {
        alert('Le numéro de téléphone doit contenir 9 chiffres (sans le +213)');
        return false;
      }

      return true;
    },

    resetForm() {
      this.form = {
        nom_prenom: '',
        email: '',
        statut: '',
        wilaya: '',
        telephone: '',
        codeclient: '',
        canal_achat: '',
        has_representant: false,
        representant_profert: '',
        gamme_produit: '',
        produit_id: '',
        numero_lot: '',
        date_livraison: '',
        quantite_non_conforme: '',
        motif: '',
        description: ''
      };
      this.produits = [];
      this.selectedFiles = [];
      this.generateCaptcha();
      this.allProduits = [];
      this.filteredProduits = [];
      this.produitSearch = '';
      this.showProduitDropdown = false;
      this.dateError = '';
      this.setMaxDate();
    },

    closeSuccessModal() {
      this.showSuccess = false;
      this.resetForm();
    },
    
    formatPhoneNumber() {
      // Supprimer tous les caractères non numériques
      let numbers = this.form.telephone.replace(/\D/g, '');
      
      // Limiter à 9 chiffres (sans le +213)
      numbers = numbers.substring(0, 9);
      
      // Mettre à jour la valeur
      this.form.telephone = numbers;
    },

    onProduitInputFocus() {
      if (this.form.gamme_produit && this.allProduits.length > 0) {
        this.showProduitDropdown = true;
        this.filterProduits();
      }
    },

    navigateDropdown(direction) {
      if (!this.showProduitDropdown || this.filteredProduits.length === 0) return;
      
      event.preventDefault();
      
      if (direction === 'down') {
        this.highlightedIndex = 
          this.highlightedIndex < this.filteredProduits.length - 1 
            ? this.highlightedIndex + 1 
            : 0;
      } else if (direction === 'up') {
        this.highlightedIndex = 
          this.highlightedIndex > 0 
            ? this.highlightedIndex - 1 
            : this.filteredProduits.length - 1;
      }
      
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdown;
        const items = dropdown?.querySelectorAll('div');
        if (items && items[this.highlightedIndex]) {
          items[this.highlightedIndex].scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      });
    },

    selectHighlightedProduit() {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredProduits.length) {
        this.selectProduit(this.filteredProduits[this.highlightedIndex]);
        this.highlightedIndex = -1;
      }
    },

    setMaxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.maxDate = `${year}-${month}-${day}`;
    },
    
    validateDateLivraison() {
      if (!this.form.date_livraison) {
        this.dateError = '';
        return true;
      }
      
      const selectedDate = new Date(this.form.date_livraison);
      const today = new Date();
      
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      if (selectedDate > today) {
        this.dateError = 'La date de livraison ne peut pas être postérieure à aujourd\'hui';
        return false;
      }
      
      const minDate = new Date('2000-01-01');
      if (selectedDate < minDate) {
        this.dateError = 'Veuillez saisir une date valide';
        return false;
      }
      
      this.dateError = '';
      return true;
    },
  }
}
</script>

<style scoped>
.font-mono {
  font-family: 'Courier New', monospace;
}

.tracking-wider {
  letter-spacing: 0.1em;
}

.select-none {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Styles pour le dropdown personnalisé */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
}

/* Assurez-vous que le dropdown apparaît au-dessus des autres éléments */
.z-50 {
  z-index: 50;
}

.max-h-60 {
  max-height: 15rem;
}

/* Style pour l'input lors de la saisie */
input:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
}

/* Animation pour le dropdown */
.dropdown-enter-active {
  animation: dropdownFadeIn 0.2s ease-out;
}

.dropdown-leave-active {
  animation: dropdownFadeOut 0.2s ease-in;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes dropdownFadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* Scroll personnalisé pour le dropdown */
.max-h-60 {
  max-height: 15rem;
}

.max-h-60::-webkit-scrollbar {
  width: 6px;
}

.max-h-60::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>